// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"RecentlyViewed_carouselWrapper___4fMx","leftToRight":"RecentlyViewed_leftToRight__g5yGM"};